import { MigrationSpec } from "../migration.models"

const personNoteIndexes: MigrationSpec = {
  type: "ENSURE_PERSON_NOTE_INDEXES",
  collection: "PersonNotes",
  risk: "INDEX",
  title: {
    en: "Contact notes: index for a contact's notes",
    tr: "Kişi notları: bir kişinin notları için index"
  },
  description: {
    en:
      "Creates `{ customer, person, createdAt: -1 }` on PersonNotes, under the name Mongoose " +
      "derives — the only read path, one contact's notes newest first. Nothing is dropped.",
    tr:
      "PersonNotes koleksiyonunda `{ customer, person, createdAt: -1 }` index'ini Mongoose'un " +
      "türettiği adla oluşturur — tek okuma yolu, bir kişinin notları en yeniden eskiye. Hiçbir " +
      "şey silinmez."
  },
  // Index-only: no document is rewritten, so nothing can be affected.
  affectedFilter: { _id: null },
  sampleFields: ["customer"],
  // Copied from PERSON_NOTE_INDEXES in api-v2's Person/core/person.constants.ts.
  indexes: {
    mustExist: [{ keys: { customer: 1, person: 1, createdAt: -1 } }]
  },
  notes: [
    {
      en:
        "A new collection: autoIndex already builds this index at boot, so the run normally only " +
        "verifies. On an empty collection the status reads PENDING rather than PARTIAL.",
      tr:
        "Yeni bir koleksiyon: autoIndex bu index'i açılışta zaten oluşturur, çalıştırma " +
        "normalde yalnızca doğrular. Boş koleksiyonda durum PARTIAL yerine PENDING görünür."
    }
  ]
}

export default personNoteIndexes
